import type { HsClippingPlane } from '../objects/clipping/clipping-plane.class';

export class HsClippingStorage {
  public static readonly default: HsClippingStorage = new HsClippingStorage();

  constructor(public readonly clippingPlanes: HsClippingPlane[] = []) {}
}
